import { all, takeEvery, put, fork } from "redux-saga/effects";
import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions/index";
import * as API from "../api";

export function* loadReviewTag() {
  yield takeEvery(actionTypes.MALL_LOAD_PRODUCT_REVIEW_TAG, function*(action) {
    try {
      const response = yield API.mallLoadProductReviewTag(
        action.id,
        action.data
      );
      if (response.data.success) {
        yield put(actions.mallLoadReviewTagSuccess(response.data.data));
      } else {
        alert(
          "Warning: Fail to load product review key. \n" + response.data.message
        );
        yield put(actions.mallLoadReviewTagFail());
      }
    } catch (error) {
      yield put(
        actions.handleAPIError(error, "Fail to load product review key. \n")
      );
      yield put(actions.mallLoadReviewTagFail());
    }
  });
}

export function* loadReviewList() {
  yield takeEvery(actionTypes.MALL_LOAD_PRODUCT_REVIEW_LIST, function*(action) {
    try {
      const response = yield API.mallLoadProductReviewList(
        action.productID,
        action.data,
        action.reviewID
      );
      if (response.data.success) {
        yield put(actions.mallLoadReviewListSuccess(response.data.data));
      } else {
        alert(
          "Warning: Fail to load product review. \n" + response.data.message
        );
        yield put(actions.mallLoadReviewListFail());
      }
    } catch (error) {
      yield put(
        actions.handleAPIError(error, "Fail to load product review. \n")
      );
      yield put(actions.mallLoadReviewListFail());
    }
  });
}

export function* mallProductReview() {
  yield takeEvery(actionTypes.MALL_PRODUCT_REVIEW, function*(action) {
    try {
      const response = yield API.mallProductReview(
        action.orderID,
        action.productID,
        action.data
      );
      if (response.data.success) {
        yield put(actions.mallPostProductReviewSuccess(response.data.data));
      } else {
        alert(
          "Warning: Fail to post product review. \n" + response.data.message
        );
      }
    } catch (error) {
      yield put(
        actions.handleAPIError(error, "Fail to post product review. \n")
      );
    }
  });
}

export function* mallProductRiderReview() {
  yield takeEvery(actionTypes.MALL_PRODUCT_RIDER_REVIEW, function*(action) {
    try {
      const response = yield API.riderReview(
        action.orderID,
        action.riderID,
        action.data
      );
      if (response.data.success) {
        yield put(actions.mallPostProductRiderReviewSuccess());
      } else {
        alert("Warning: Fail to post rider review. \n" + response.data.message);
      }
    } catch (error) {
      yield put(actions.handleAPIError(error, "Fail to post rider review. \n"));
    }
  });
}

export function* mallLikedProduct() {
  yield takeEvery(actionTypes.MALL_LIKED_PRODUCT, function*(action) {
    try {
      const response = yield API.mallLikedProduct(action.data.reviewID);
      if (response.data.success) {
        let like = "";
        if (action.data.likes_status === 0) {
          like = "Unliked Review Successful";
        } else {
          like = "Liked Review Successful";
        }
        yield put(actions.toastSuccess(like));
      } else {
        alert("Warning: Fail to like product. \n" + response.data.message);
      }
    } catch (error) {
      yield put(actions.handleAPIError(error, "Fail to like product. \n"));
    }
  });
}

export default function* mallReviewSaga() {
  yield all([
    fork(loadReviewTag),
    fork(loadReviewList),
    fork(mallProductReview),
    fork(mallProductRiderReview),
    fork(mallLikedProduct)
  ]);
}
